module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "homeTestimonials"
    }
  }, [_c('div', {
    staticClass: "container"
  }, _vm._l((_vm.shuffledTestimonials), function(testimonial, index) {
    return _c('div', {
      staticClass: "slide",
      class: _vm.isActiveSlide(index) ? 'active' : ''
    }, [_c('div', {
      staticClass: "circleHeader"
    }, [_c('h2', [_c('span', [_vm._v("The Longest Shortest Time is a parenting show for everyone.")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(testimonial.first_name) + " likes it...")])])]), _vm._v(" "), _c('div', {
      staticClass: "testimonial"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(testimonial.quote)
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "attribution"
    }, [_c('em', [_vm._v("—" + _vm._s(testimonial.attribution))])]), _vm._v(" "), _c('div', [(_vm.testimonials.length > 1) ? _c('button', {
      on: {
        "click": _vm.nextTestimonial
      }
    }, [_c('span', [_vm._v("More Praise")]), _vm._v(" "), _c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "4262.82 9804.78 34.581 48.995",
        "width": "35",
        "height": "49"
      }
    }, [_c('path', {
      attrs: {
        "d": "M-19.71,54.92,11,32.33a2,2,0,0,0,0-3.14L-19.71,6.6a2,2,0,0,0-2.013-.123,2,2,0,0,0-1.1,1.693V53.35a2,2,0,0,0,1.1,1.693A2,2,0,0,0-19.71,54.92Z",
        "transform": "translate(4285.64 9798.518)"
      }
    })])]) : _vm._e()])])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-025c423c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/Testimonials.vue
// module id = 754
// module chunks = 1